/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateImportPreviewMutationRequest,
  UpdateImportPreviewMutationResponse,
  UpdateImportPreviewPathParams,
  UpdateImportPreview400,
  UpdateImportPreview404,
} from '../types/UpdateImportPreview'

function getUpdateImportPreviewUrl({
  import_number,
}: {
  import_number: UpdateImportPreviewPathParams['import_number']
}) {
  const res = {
    method: 'PATCH',
    url: `/api/v1/importengine/previews/v2/${import_number}/` as const,
  }
  return res
}

/**
 * @summary Update an import preview's rows and/or raw data
 * {@link /api/v1/importengine/previews/v2/:import_number/}
 */
export async function updateImportPreview(
  {
    import_number,
  }: { import_number: UpdateImportPreviewPathParams['import_number'] },
  data?: UpdateImportPreviewMutationRequest,
  config: Partial<RequestConfig<UpdateImportPreviewMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateImportPreviewMutationResponse,
    ResponseErrorConfig<UpdateImportPreview400 | UpdateImportPreview404>,
    UpdateImportPreviewMutationRequest
  >({
    method: 'PATCH',
    url: getUpdateImportPreviewUrl({ import_number }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
